export interface IRecipientActivityLog {
    id: number,
    activity: string,
    activityId: number,
    activityDate: string,
    deadlineDate: string,
    type: string,
    potentialDonorId: number,
    potentialDonor: string,
    potentialDonorCenter: string,
    potentialDonorAge: number,
    singleEpletMmDr: number,
    singleEpletMmDq: number,
    singleEpletMmDqLow: number,
    outcome: string,
    outcomeReason: string,
}
